import { html, render } from "lit-html";
import {
	dateIterator,
	formatISODate,
	getNumMonthsContaining,
} from "@escapio/shared/l10n/date";
import {
	onChangeDates,
	travelData,
	updateDates,
} from "@escapio/portal/state/travelData";
import { getFormatter } from "@escapio/shared/l10n/currency";

customElements.define(
	"esc-availability-calendar-input",
	class extends HTMLElement {
		async connectedCallback() {
			const rateId = this.getAttribute("rate-id");
			const response = await fetch(`/pna/calendar/${rateId}`);
			this.availabilities = await response.json();

			onChangeDates(() => this.render());
			this.render();
		}

		render() {
			const formatCurrency = getFormatter(travelData.currency);
			const numMonths = getNumMonthsContaining(
				new Date(),
				new Date(Object.keys(this.availabilities).at(-1) || ""),
			);

			const template = html`<esc-calendar-input
				.arrival=${travelData.arrival}
				.departure=${travelData.departure}
				min-duration="${this.getAttribute("min-duration")}"
				max-duration="${this.getAttribute("max-duration")}"
				num-months="${numMonths}"
				@confirm=${this.confirmDates}
				.renderDayAddonsFn=${date =>
					html`<div class="calendar__addon">
						${this.availabilities[formatISODate(date)]
							? formatCurrency(this.availabilities[formatISODate(date)].price)
							: ""}
					</div>`}
				.extraValidationFn=${(start, end) =>
					dateIterator(start, end, false).every(
						date => this.availabilities[formatISODate(date)]?.price,
					)}
			></esc-calendar-input>`;
			render(template, this, { host: this });
		}

		confirmDates({ detail }) {
			updateDates(detail.arrival, detail.departure);
		}
	},
);
